export const messagesAutomation = {
    pt: {
        message:{
            accessMade: "Acesso realizado",
            addAction: "Adicionar Ação",
            andSendAt: " e enviar às ",
            automationName: "Nome da automação",
            birthday: "Aniversário",
            birthdayIn: "Aniversário em ",
            businessHours: "Ir para a próxima etapa somente em horário comercial (das 9h às 18h)",
            campaign: "Campanha",
            campaigns: "Campanhas",
            changesToBeSaved: "Alterações a serem salvas",
            considerWeekends: "Considerar finais de semana no intervalo de espera",
            createAutomation: "Criar automação",
            creationDate: "Criação",
            customerPerformed: "Cliente realizou",
            customerWithoutAccessFor: "Cliente sem acesso há",
            day: "dia",
            days: "dias",
            deleteAutomation: "Deletar Automação?",
            deleteAutomationConfirmation: "Quer mesmo deletar esta automação? Esta ação é irreversível",
            doNotRepeat: "Não repetir",
            doNotRepeatHint: "Seu cliente passará apenas uma vez no fluxo. Próximas vezes em que preencher a condição de entrada, o cliente será ignorado.",
            extraFields: "Campos extras",
            filters: "Filtros",
            flowInput: "Entrada do fluxo",
            hasBirthdayIn: "Faz aniversário em",
            hour: "hora",
            hours: "horas",
            lastEdit: "Última Edição",
            minute: "minuto",
            minutes: "minutos",
            newAutomation: "Nova automação",
            no: "Não",
            noCampaignsRegistered: "Nenhuma campanha cadastrada",
            noExtraFields: "Sem campos extras",
            noSpotRegistered: "Nenhum local cadastrado",
            noUseTerms: "Sem Termos de Uso",
            numberOfAccesses: "Número de acessos",
            periodWithoutAccess: "Período sem acesso",
            rangeOfDays: "Intervalo de dias",
            removeSendingTime: "Remover horário de envio",
            rename: "Renomear",
            repeat: "Repetir",
            repeatEvery: "Repetir a cada",
            repeatHint: "Sempre que seu cliente preencher as condições de entrada, passará pelo fluxo novamente.",
            repeatInterval: "Repetir a cada intervalo de dias",
            repeatIntervalHint: "Seu cliente voltará a entrar no fluxo preenchendo a condição de entrada após a data de intervalo definida.",
            scheduleSendingTime: "Agendar horário de envio",
            select: "Selecionar",
            selectGender: "Selecione o sexo",
            sendAt: "Enviar às",
            sendEmail: "Enviar e-mail",
            sendSms: "Enviar SMS",
            sendWhatsapp: "Enviar Whatsapp",
            sendingOptions: "Opções de envio",
            setCriteria: "Definir critério",
            setEmail: "Definir e-mail",
            setEntryCriteria: "Definir critério de entrada",
            setRepetition: "Definir repetição",
            setSms: "Definir SMS",
            setWhatsapp: "Definir Whatsapp",
            setSpots: "Definir locais",
            setWaitInterval: "Definir intervalo de espera",
            tooltipAddStep: "Para adicionar uma nova etapa, é necessário salvar as etapas já adicionadas",
            tooltipAutomationName: "Nome que será utilizado para identificar a automação dentro do WiFeed.",
            useTerms: "Termos de Uso",
            wait: "Esperar ",
            waitingRules: "Regras de espera",
            yes: "Sim"
        }
    },
    es: {
        message:{
            accessMade:"Acceso realizado",
            addAction:"Agregar acción",
            andSendAt:"y enviar a",
            automationName:"Nombre de automatización",
            birthday:"Cumpleaños",
            birthdayIn:"Cumpleaños en",
            businessHours:"Vaya a la siguiente etapa solo durante el horario comercial (de 9 a.m. a 6 p.m.)",
            campaign: "Campaña",
            campaigns: "Campañas",
            changesToBeSaved:"Cambios para ser guardados",
            considerWeekends:"Considere los fines de semana en el intervalo de espera",
            createAutomation:"Crear automatización",
            creationDate:"F. Creación",
            customerPerformed:"Cliente realizó",
            customerWithoutAccessFor:"Cliente sin acceso allí",
            day:"día",
            days:"dias",
            deleteAutomation:"¿Eliminar la automatización?",
            deleteAutomationConfirmation:"¿Realmente quieres eliminar esta automatización? Esta acción es irreversible",
            doNotRepeat:"No repita",
            doNotRepeatHint:"Su cliente solo pasará una vez en el flujo. Las próximas veces que cumpla con la condición de entrada, el cliente será ignorado",
            extraFields: "Campos adicionales",
            filters: "Filtros",
            flowInput:"Entrada de flujo",
            hasBirthdayIn:"Tienes un cumpleaños en",
            hour:"hora",
            hours:"Horas",
            lastEdit:"Última edición",
            minute:"minuto",
            minutes:"minutos",
            newAutomation:"Nueva automatización",
            no: "No",
            noCampaignsRegistered: "No hay campañas registradas",
            noExtraFields: "Sin campos adicionales",
            noSpotRegistered:"No hay local registrado",
            noUseTerms: "Sin Términos de Uso",
            numberOfAccesses:"Número de accesos",
            periodWithoutAccess:"Período sin acceso",
            rangeOfDays:"Intervalo de día",
            removeSendingTime:"Eliminar el tiempo de envío",
            rename:"Renombrar",
            repeat:"Repetir",
            repeatEvery:"Repetir cada",
            repeatHint:"Cada vez que su cliente cumpla con las condiciones de entrada, volverá a pasar por el flujo",
            repeatInterval:"Repetir cada intervalo de días",
            repeatIntervalHint:"Su cliente volverá a ingresar el flujo completando la condición de entrada después de la fecha establecida establecida",
            scheduleSendingTime:"Agende horario de envío",
            select:"Seleccionar",
            selectGender: "Seleccione género",
            sendAt:"Enviar a",
            sendEmail:"Enviar correo electrónico",
            sendSms:"Enviar SMS",
            sendWhatsapp: "Enviar Whatsapp",
            sendingOptions:"Opciones de envío",
            setCriteria:"Definir criterios",
            setEmail:"Definir correo electrónico",
            setEntryCriteria:"Definir criterios de entrada",
            setRepetition:"Definir repetición",
            setSms:"Establecer SMS",
            setWhatsapp: "Establecer Whatsapp",
            setSpots:"Definir ubicaciones",
            setWaitInterval:"Definir intervalo de espera",
            tooltipAddStep:"Para agregar un nuevo paso, es necesario guardar los pasos ya agregados",
            tooltipAutomationName:"Nombre que se utilizará para identificar la automatización dentro de WiFeed",
            useTerms: "Términos de Uso",
            wait:"Esperar ",
            waitingRules:"Reglas de espera",
            yes: "Sí"
        }
    },
    en: {
        message:{
            accessMade: "Access made",
            addAction: "Add Action",
            andSendAt: " and send at ",
            automationName: "Automation name",
            birthday: "Birthday",
            birthdayIn: "Birthday in ",
            businessHours: "Go to the next step only during business hours (9 am to 6 pm)",
            campaign: "Campaign",
            campaigns: "Campaigns",
            changesToBeSaved: "Changes to be saved",
            considerWeekends: "Consider weekends in the waiting interval",
            createAutomation: "Create automation",
            creationDate: "Creation",
            customerPerformed: "Customer performed",
            customerWithoutAccessFor: "Customer without access for",
            day: "day",
            days: "days",
            deleteAutomation: "Delete Automation?",
            deleteAutomationConfirmation: "Do you really want to delete this automation? This action is irreversible",
            doNotRepeat: "Do not repeat",
            doNotRepeatHint: "Your client will only pass once in the flow. Next times when fulfilling the input condition, the customer will be ignored.",
            extraFields: "Extra fields",
            filters: "Filters",
            flowInput: "Flow input",
            hasBirthdayIn: "Birthday in",
            hour: "hour",
            hours: "hours",
            lastEdit: "Last Edit",
            minute: "minute",
            minutes: "minutes",
            newAutomation: "New automaton",
            no: "No",
            noCampaignsRegistered: "No campaigns registered",
            noExtraFields: "No extra fields",
            noSpotRegistered: "No spot registered",
            noUseTerms: "No Use Terms",
            numberOfAccesses: "Number of accesses",
            periodWithoutAccess: "Period without access",
            rangeOfDays: "Range of days",
            removeSendingTime: "Remove shipping time",
            rename: "Rename",
            repeat: "Repeat",
            repeatEvery: "Repeat every",
            repeatHint: "Whenever your customer fulfills the entry conditions, it will go through the flow again.",
            repeatInterval: "Repeat every day interval",
            repeatIntervalHint: "Your customer will re-enter the flow by fulfilling the entry condition after the defined interval date.",
            scheduleSendingTime: "Schedule sending time",
            select: "Select",
            selectGender: "Select gender",
            sendAt: "Send at",
            sendEmail: "Send email",
            sendSms: "Send SMS",
            sendWhatsapp: "Send Whatsapp",
            sendingOptions: "Sending options",
            setCriteria: "Set criteria",
            setEmail: "Set e-mail",
            setEntryCriteria: "Set entry criteria",
            setRepetition: "Set repetition",
            setSms: "Set SMS",
            setWhatsapp: "Set Whatsapp",
            setSpots: "Set spots",
            setWaitInterval: "Set wait interval",
            tooltipAddStep: "To add a new step, you need to save the already added steps",
            tooltipAutomationName: "Name that will be used to identify the automation within WiFeed.",
            useTerms: "Use Terms",
            wait: "Wait ",
            waitingRules: "Waiting rules",
            yes: "Yes"
        }
    }
}
